import React, {useEffect, useState, useImperativeHandle, useRef} from 'react'
import {
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input, message,
  Radio,
  Row,
  Select,
  TimePicker
} from "antd";
import moment from 'moment';
import {getActivityMainAdd} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

const RadioGroup = Radio.Group;
const format = 'YYYY-MM-DD HH:mm:ss';
const FormItem = Form.Item
const Option = Select.Option;
const dateOptions = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    sm: {span: 8},
  },
  wrapperCol: {
    xs: {span: 24},
    sm: {span: 16},
  },
}
export default ({activityInfoRef, templateId}) => {
  const [activityType, setActivityType] = useState(2)
  const [showActivityChildType, setShowActivityChildType] = useState(false)
  const [showDayLimit, setShowDayLimit] = useState(true)
  const [showActivityLimit, setShowActivityLimit] = useState(false)
  const [buyLimit, setBuyLimit] = useState(1)
  const [weekDays, setWeekDays] = useState(dateOptions)
  const [checkAll, setCheckAll] = useState(true)
  const [indeterminate, setIndeterminate] = useState(false)
  const [selectedRowKeysSync, setSelectedRowKeysSync] = useState([])

  const [productNum, setProductNum] = useState(4)
  const [type, setType] = useState(1)
  const types = [
    {id: 1, value: '商品直降'},
    {id: 2, value: 'N选1'}]

  const [timeInterval, setTimeInterval] = useState(1)

  const formRef = useRef()

  useEffect(() => {
    if (activityType === 8) {
      setShowActivityChildType(true)
    } else {
      setShowActivityChildType(false)
    }
  }, [activityType])


  useImperativeHandle(activityInfoRef, () => ({
    onSubmit: onFinish
  }))

  /**
   * @Description: 表单提交
   * @Author Jiang
   * @Date 2020/9/4 16:41
   */
  const onFinish = (current, callback, callback2) => {
    console.log(formRef.current.getFieldValue())
    let values = formRef.current.getFieldValue()
    let tempWeek = getWeekDayNumber(values.weekDay).join(",")
    console.log(tempWeek)
    let beginDate = moment(values.beginDate).format('YYYY-MM-DD HH:mm:ss')
    let endDate = moment(values.endDate).format('YYYY-MM-DD HH:mm:ss')
    let openTime = '00:00:00'
    let closeTime ='23:59:59'

    if (timeInterval == 1) {
      openTime = '00:00:00'
      closeTime = '23:59:59'
    } else {
      openTime = moment(values.openTime).format('HH:mm:ss')
      closeTime = moment(values.closeTime).format('HH:mm:ss')
    }

    // console.log(values.beginDate)
    // console.log('++++++++++++++++++' + values.beginDate)
    // console.log('++++++++++++++++++' + values.endDate)
    // console.log('++++++++++++++++++' + moment(values.openTime).format('YYYY-MM-DD HH:mm:ss'))
    // console.log('++++++++++++++++++' + moment(values.closeTime).format('YYYY-MM-DD HH:mm:ss'))
    // console.log('++++++++++++++++++' + values.activityPrice)
    // console.log('++++++++++++++++++' + type)
    // console.log(beginDate)
    // console.log(closeTime)
    let activtype = 2;
    let childType = 0;
    if (values.activitytypeN == 1) {
      activtype = 2;
      childType = 0;
    } else {
      activtype = 32;
      childType = 2;
    }
    //表单验证
    if (!values.activityName) {
      message.error("请输入活动名称", 1)
      return false
    }

    if ((!values.beginDate) || (!values.endDate)) {
      return message.error("请选择活动日期", 1)
    }
    if (timeInterval == 2) {
      if ((!values.openTime) || (!values.closeTime)) {
        message.error("请选择生效时间", 1)
        return false
      }
    }

    if (!values.weekDay) {
      message.error("请选择活动时间", 1)

    }
    if ((!values.storeUserDayLimit) && (!values.storeUserLimit)) {
      message.error("请填入限购件数", 1)
      return false
    }

    if (!values.activityPrice && type == 2) {
      message.error("请输入活动价格", 1)
      return false
    }

    let storage = window.localStorage;
    storage.setItem('ACTIVITY_TYPE', activtype);
    storage.setItem('ACTIVITY_P', values.activityPrice);

    getActivityMainAdd({
      activityChildType: childType,
      activityName: values.activityName,
      activityDesc: '',
      activityType: activtype, //活动类型,2：商品直降；8：品类满减；32: 第N件特价或买N赠M或N选1；0：其他
      beginDate: beginDate,
      closeTime: closeTime,
      // ruleinfo: "",
      deliveryType: 1, //配送方式 1配送 2自提 3配送+自提，默认1 配送
      endDate: endDate,
      openTime: openTime,
      platformType: 5,
      showStatus: 2, //活动状态，2 生效/未开始，3 下线
      storeUserDayLimit: values.storeUserDayLimit,
      storeUserLimit: values.storeUserLimit,
      templateId: templateId,
      userType: values.userType, //支持的用户类型 0 全部用户 2 门店新用户, 第N件特价填0(第N件只有全部顾客);3：指定用户
      weekDay: tempWeek,
      ruleInfo: type == 2 ? JSON.stringify([{meet_conditions: productNum, special_price: values.activityPrice}]): ''
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let activityId = data.data
          message.success('添加成功', 1)
          callback2(activityId)
          current += 1
          callback(current)
          return activityId
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_ADD_ACTIVITY_INFO, {
    //   activityChildType: childType,
    //   activityName: values.activityName,
    //   activityDesc: '',
    //   activityType: activtype, //活动类型,2：商品直降；8：品类满减；32: 第N件特价或买N赠M或N选1；0：其他
    //   beginDate: beginDate,
    //   closeTime: closeTime,
    //   // ruleinfo: "",
    //   deliveryType: 1, //配送方式 1配送 2自提 3配送+自提，默认1 配送
    //   endDate: endDate,
    //   openTime: openTime,
    //   platformType: 5,
    //   showStatus: 2, //活动状态，2 生效/未开始，3 下线
    //   storeUserDayLimit: values.storeUserDayLimit,
    //   storeUserLimit: values.storeUserLimit,
    //   templateId: templateId,
    //   userType: values.userType, //支持的用户类型 0 全部用户 2 门店新用户, 第N件特价填0(第N件只有全部顾客);3：指定用户
    //   weekDay: tempWeek,
    //   ruleInfo: type == 2 ? JSON.stringify([{meet_conditions: productNum, special_price: values.activityPrice}]): ''
    // }).then((response) => {
    //   let data = response.data;
    //   console.log(data)
    //   if (data.code === 0) {
    //     let activityId = data.data
    //     message.success('添加成功', 1)
    //     callback2(activityId)
    //     current += 1
    //     callback(current)
    //     return activityId
    //   } else {
    //     message.error(data.msg)
    //   }
    // }).catch(function (error) {
    //   console.log(error);
    // });

  }

  /**
   * @Description: 星期根据字符串获取数字
   * @Author Jiang
   * @Date 2020/9/8 11:21
   */
  const getWeekDayNumber = (week) => {
    let tempWeek = []
    week.map((item, index) => {
      switch (item) {
        case "周日":
          tempWeek.push(0);
          break;
        case "周一":
          tempWeek.push(1);
          break;
        case "周二":
          tempWeek.push(2);
          break;
        case "周三":
          tempWeek.push(3);
          break;
        case "周四":
          tempWeek.push(4);
          break;
        case "周五":
          tempWeek.push(5);
          break;
        case "周六":
          tempWeek.push(6);
          break;
      }
    })
    return tempWeek
  }


  /**
   * @Description: 活动日期选择
   * @Author Jiang
   * @Date 2020/9/4 16:42
   */
  const onChangeWeek = (checkedList) => {
    formRef.current.setFieldsValue({
      weekDay: checkedList
    })
    setIndeterminate(!!checkedList.length && checkedList.length < dateOptions.length)
    setCheckAll(checkedList.length === dateOptions.length)
  }

  /**
   * @Description 选择整周
   * @Author Jiang
   * @Date 2020/9/8 10:26
   */
  const onCheckAllChange = (e) => {
    setIndeterminate(false)
    setCheckAll(e.target.checked)
    let checkedList = e.target.checked ? dateOptions : []
    formRef.current.setFieldsValue({
      weekDay: checkedList
    })
  }

  /**
   * @Description: 售卖时间段
   * @Author Jiang
   * @Date 2020/9/4 16:51
   */
  const onChangeTimeinterval = e => {
    setTimeInterval(e.target.value)
  }

  /**
   * @Description: 修改活动类型
   * @Author Jiang
   * @Date 2020/9/5 11:06
   */
  const onChangeActivityType = (e) => {
    setActivityType(e.target.value)
  }

  /**
   * @Description: 修改限购设置
   * @Author Jiang
   * @Date 2020/9/5 11:48
   */
  const onChangeBuyLimit = (e) => {
    setBuyLimit(e.target.value)
    if (e.target.value === 1) {
      setShowActivityLimit(false)
      setShowDayLimit(true)
    } else {
      setShowActivityLimit(true)
      setShowDayLimit(false)
    }
  }

  const changeInputNum = e => {
    const {value} = e.target;
    setProductNum(value)
  }
  const changeType = value => {
    setType(value)
  }

  return (
    <Form ref={formRef}
          initialValues={{
            weekDay: weekDays,
            userType: 0,
            activityType: 2,
            buyLimit: 1,
          }}>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
        <Col className={['gutter-row']} offset={4} span={2}>
          <div className='input-title'>基本信息</div>
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='activitytypeN' label="活动类型"
                    rules={[{required: true, message: '请输入活动类型',}]} {...formItemLayout}>
            <Select
                style={{marginLeft: "20px"}}
                placeholder="活动类型"
                className="header-search"
                bordered={true}
                onChange={changeType}
            >
              {
                types.map((item,index) => {
                  return <Option key={index} value={item.id}>{item.value}</Option>
                })
              }
            </Select>
          </FormItem>
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='activityName' label="活动名称"
                    rules={[{required: true, message: '请输入活动名称',}]} {...formItemLayout}>
            <Input style={{marginLeft: "20px"}} placeholder="请输入活动名称"/>
          </FormItem>
        </Col>
      </Row>


      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem label="活动日期" rules={[{required: true, message: "请选择活动日期"}]} {...formItemLayout}>
            <div style={{display: "flex", flexDirection: "row", marginLeft: "20px",}}>
              <FormItem name='beginDate' rules={[{required: true, message: "请选择开始日期"}]}>
                <DatePicker
                  showTime={{defaultValue: moment('00:00:00', 'HH:mm:ss')}}
                  // defaultValue={moment('00:00', format)}
                  style={{width: '200px'}}
                  placeholder={'开始日期'}
                  format={format}
                />
              </FormItem>
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "20px",
                marginRight: "20px",
                height: "32px",
              }}>至
              </div>
              <FormItem name='endDate'
                        rules={[{required: true, message: "请选择结束日期"}]}>
                <DatePicker
                  showTime={{defaultValue: moment('00:00:00', 'HH:mm:ss')}}
                  style={{width: '200px'}}
                  placeholder={'结束日期'}
                  // defaultValue={moment('00:00', format)}
                />
              </FormItem>
            </div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={8} span={18}>
          <div style={{display: "flex", flexDirection: "row",}}>
            <FormItem label='活动时间' rules={[{required: true, message: "请选择活动时间"}]}>
              <Checkbox
                style={{marginLeft: "20px"}}
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
              >
                整周
              </Checkbox>
            </FormItem>
            <FormItem name={'weekDay'} rules={[{required: true, message: "请选择活动时间"}]}>
              <Checkbox.Group options={dateOptions}
                              value={weekDays}
                              onChange={onChangeWeek}/>
            </FormItem>
          </div>
        </Col>
      </Row>
      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10}>*/}
      {/*    <FormItem label="生效时间" rules={[{required: true, message: "请选择活动时间"}]} {...formItemLayout}>*/}
      {/*      <div style={{display: "flex", flexDirection: "row", marginLeft: "20px",}}>*/}
      {/*        <FormItem name='openTime' rules={[{required: true, message: "请选择开始日期"}]} {...formItemLayout}>*/}
      {/*          <TimePicker*/}
      {/*            // defaultValue={moment('00:00', format)}*/}
      {/*            style={{width: "160px"}}*/}
      {/*            placeholder={'开始时间'}*/}
      {/*          />*/}
      {/*        </FormItem>*/}
      {/*        <div style={{*/}
      {/*          display: "flex",*/}
      {/*          justifyContent: "center",*/}
      {/*          alignItems: "center",*/}
      {/*          marginLeft: "20px",*/}
      {/*          marginRight: "20px",*/}
      {/*          height: "32px",*/}
      {/*        }}>至*/}
      {/*        </div>*/}
      {/*        <FormItem name='closeTime' rules={[{required: true, message: "请选择结束日期"}]}>*/}
      {/*          <TimePicker*/}
      {/*            placeholder={'结束时间'}*/}
      {/*            style={{width: "160px"}}*/}
      {/*            // defaultValue={moment('00:00', format)}*/}
      {/*          />*/}
      {/*        </FormItem>*/}
      {/*      </div>*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}


      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem label='生效时段' name={""} rules={[{required: true, message: "请选择生效时段"}]} {...formItemLayout}>
            <RadioGroup
              onChange={onChangeTimeinterval}
              style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginLeft: "20px"}}
              defaultValue={timeInterval}>
            >
              <Radio value={1}>全天</Radio>
              <Radio value={2}>自定义</Radio>
            </RadioGroup>
            <div style={{marginTop: 10}}>
              {
                timeInterval == 1? null :
                    <div>
                      <div style={{display: "flex", flexDirection: "row", marginLeft: "20px",}}>
                        <FormItem name='openTime' rules={[{required: true, message: "请选择开始日期"}]} {...formItemLayout}>
                          <TimePicker
                              // defaultValue={moment('00:00', format)}
                              style={{width: "160px"}}
                              placeholder={'开始时间'}
                          />
                        </FormItem>
                        <div style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginLeft: "20px",
                          marginRight: "20px",
                          height: "32px",
                        }}>至
                        </div>
                        <FormItem name='closeTime' rules={[{required: true, message: "请选择结束日期"}]}>
                          <TimePicker
                              placeholder={'结束时间'}
                              style={{width: "160px"}}
                              // defaultValue={moment('00:00', format)}
                          />
                        </FormItem>
                      </div>
                    </div>
              }
            </div>
          </FormItem>
        </Col>
      </Row>

      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10}>*/}
      {/*    <FormItem label='订单类型'  {...formItemLayout}>*/}
      {/*      <RadioGroup*/}
      {/*        style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginLeft: "20px"}}*/}
      {/*      >*/}
      {/*        <Radio value={1}>仅外卖生效</Radio>*/}
      {/*      </RadioGroup>*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}

      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={4} span={16}>
          <Divider/>
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="top">
        <Col className={['gutter-row',]} offset={4} span={2}>
          <div className='input-title'>活动规则</div>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='userType' label="顾客类型"
                    rules={[{required: true, message: '请选择顾客类型',}]} {...formItemLayout}>
            <RadioGroup
              style={{display: "flex", flexDirection: "row", marginLeft: "20px"}}
              onChange={onChangeTimeinterval}
              // value={this.state.timeInterval}>
            >
              <Radio value={0}>全部顾客</Radio>
              <Radio value={2}>门店新客</Radio>
              <Radio value={3}>超级会员</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      {/* <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='activityType' label="活动类型"
                    {...formItemLayout}>
            <RadioGroup
              onChange={onChangeActivityType}
              style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginLeft: "20px"}}
              // value={this.state.timeInterval}>
            >
              <Radio value={2}>商品直降</Radio>
              <Radio value={8}>品类满减</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>*/}
      {showActivityChildType ?
        <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
          <Col className='gutter-row' offset={8} span={12}>
            <FormItem name='activityChildType'
                      {...formItemLayout}>
              <RadioGroup
                onChange={onChangeTimeinterval}
                style={{display: "flex", flexDirection: "row", justifyContent: "flex-start",}}
                // value={this.state.timeInterval}>
              >
                <Radio value={1}>第N件特价</Radio>
                <Radio value={2}>N选1</Radio>
                <Radio value={3}>买N赠N</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row> : null
      }
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name={'buyLimit'} label="限购设置"
                    {...formItemLayout}>
            <RadioGroup
              onChange={onChangeBuyLimit}
              style={{display: "flex", flexDirection: "column", alignItems: "flex-start", marginLeft: "20px"}}
              // value={this.state.timeInterval}>
            >
              <div style={{display: "flex", flexDirection: "row"}}>
                <Radio value={1}>每人每天限购</Radio>
                {showDayLimit ?
                  <FormItem name='storeUserDayLimit'
                            {...formItemLayout}>
                    <Input addonAfter={"件"} style={{marginLeft: "20px"}}/>
                  </FormItem> : null
                }
              </div>
              <div style={{display: "flex", flexDirection: "row"}}>
                <Radio value={2}>每人活动期间限购</Radio>
                {showActivityLimit ?
                  <FormItem name='storeUserLimit'
                            {...formItemLayout}>
                    <Input addonAfter={"件"} style={{marginLeft: "20px"}}/>
                  </FormItem>
                  : null}
              </div>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>

      {
        type === 1 ? null :
            <div>
              <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
                <Col className='gutter-row' offset={6} span={10}>
                  <FormItem name='productNum' label="商品数量"
                            rules={[{required: true, message: '请输入商品数量',}]} {...formItemLayout}>
                    <Input style={{marginLeft: "20px"}} disabled defaultValue={productNum} placeholder="请输入商品数量"
                        // onChange={changeInputNum}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
                <Col className='gutter-row' offset={6} span={10}>
                  <FormItem name='activityPrice' label="活动价格"
                            rules={[{required: true, message: '请输入活动价格',}]} {...formItemLayout}>
                    <Input style={{marginLeft: "20px"}} placeholder="请输入活动价格"/>
                  </FormItem>
                </Col>
              </Row>
            </div>
      }
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/pages/activitys/add-activity/activity-info/index.js